import { quantityValueText, volumeValueText, weightValueText } from 'src/components/dispatch/metricText';
import { UnassignedItem } from 'src/entities/dispatch';

export type UnassignedTooltipRow = { label: string; value: string };
export type UnassignedTooltipVM = { title: string; rows: UnassignedTooltipRow[] };

/**
 * 未割当ピンのホバーに出す内容。
 *
 * サンプル (route-planner components/dispatch/MapView.tsx:186-224) と同じ 6 項目。
 * 詳細カードはクリックで出す（ホバーで出すと、地図を横切るだけで開閉して読めない）。
 */
export function buildUnassignedTooltip(item: UnassignedItem): UnassignedTooltipVM {
  // 未設定を空欄にすると「取れていない」のか「0」なのか読めない
  const cases = item.cases ?? 0;
  const weight = item.weight ?? 0;
  const volume = item.volume ?? 0;
  const invoiceCount = item.invoiceCount ?? (item.invoices?.length ?? 0);
  // 指定が無くても降地・積地の時間枠は運行の目安になる
  const time = item.designatedTimeWindow || item.destTimeWindow || item.originTimeWindow || '指定なし';
  const shippers = item.shippers ?? [];

  return {
    title: item.storeName ?? '',
    rows: [
      // 丸め方と桁区切りは他の表示と共通（metricText）。生の値を出すと
      // 浮動小数の足し算の端数がそのまま見える
      { label: '数量', value: `${quantityValueText(cases)} cs` },
      { label: '重量', value: `${weightValueText(weight)} kg` },
      { label: '体積', value: `${volumeValueText(volume)} m³` },
      { label: '伝票', value: `${invoiceCount} 枚` },
      { label: '指定時間', value: time },
      { label: '荷主', value: shippers.length > 0 ? shippers.join(', ') : '—' },
    ],
  };
}

/** マーカーは id しか持たないので、id から引ける形にして渡す */
export function buildUnassignedTooltipMap(
  items: readonly UnassignedItem[],
): Map<string, UnassignedTooltipVM> {
  return new Map(items.map((item) => [item.id, buildUnassignedTooltip(item)]));
}
